// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"477bd42a","138":"93a26845","195":"fa893049","212":"50efc8c8","220":"2938463e","456":"b2b3fae4","481":"5a12e259","662":"a23c6d21","757":"5065593e","808":"678901ba","829":"5af5b23b","848":"36f51c30","871":"77b2966a"}[chunkId] + ".js";
};